// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"55037475","257":"d5c0df63","265":"08f58fc4","299":"70dd42c2","527":"09c22a4b","774":"1e012b19","789":"bb89de5e"}[chunkId] + ".chunk.js";
};